import $ from 'jquery';

if( $( "html" ).attr("dir") == "rtl" ) {
	var rtl = true;
} else {
	var rtl = false;
}


$( '.js-hero-slider' ).slick( {
	rtl: rtl,
	dots: true,
	rows: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				adaptiveHeight: true,
			}
		},
		{
			breakpoint: 768,
			settings: {
				adaptiveHeight: true,
				arrows: false,
			}
		}
	],
} );

// no dots, arrows on desktop and mobile
$( '.js-hero-slider-alt' ).slick( {
	rtl: rtl,
	dots: false,
	rows: false,
} );

// no dots, arrows on desktop and mobile, adaptive height
$( '.js-hero-slider-alt-adaptive' ).slick( {
	rtl: rtl,
	dots: false,
	rows: false,
	adaptiveHeight: true
} );
